import { render, staticRenderFns } from "./3dtype.vue?vue&type=template&id=2ded34e9&scoped=true&"
import script from "./3dtype.vue?vue&type=script&lang=js&"
export * from "./3dtype.vue?vue&type=script&lang=js&"
import style0 from "./3dtype.vue?vue&type=style&index=0&id=2ded34e9&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ded34e9",
  null
  
)

export default component.exports